module.exports = __webpack_public_path__ + "static/media/03_Yale-University.4e773cd2.gif";